export default __webpack_public_path__ + "static/media/screen.1d7bb48e.png";